export default {
  view: {
    data: null,
    loading: false,
    error: null
  }
} as RetailMediaAccountInfoState
